import { useState, useEffect } from "react";
import './SignUp.scss'
import { NavLink } from "react-router-dom";
import { register_user, sing_in, autoSignInSubUser } from "../../../server/requests";
import { useRouter } from "../../../hooks/router";
import { generate_id, info_device, translateWord,crypt } from "../../Util/util";
import ErrorMessage from "../../AlertMessage/ErrorMessage";
import Loading from "../../Loading/Loading";
import SignUpModal from "./SignUpModal";

export default function SignUp() {
    const router = useRouter()

    const [validate, setValidate] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const [messageType, setMessageType] = useState('')
    const [modalIframe, setModalIframe] = useState(false)
    const [iframeUrl, setIframeUrl] = useState('')
    const [closeIframe, setCloseIframe] = useState(false)
    const [isCheckedInp, setIsCkechedInp] = useState(false)
    const [isDisabeled, setisDisabeled] = useState('')
    const [agreement, setAgreement] = useState(false)
    const [iframeTitle, setIframeTitle] = useState('')
    const [signingIn, setSigningIn] = useState(false)

    const [validateEmailVal, setValidateEmailVal] = useState(false)
    const [formData, setFormData] = useState({
        name: '',
        code: '',
        phone: '',
        parental_code: '0000',
        c_password: '',
        password: '',
    })

    useEffect(() => {


        if (!localStorage.getItem('device_id')) {
            localStorage.setItem('device_id', generate_id())
        }

        if (router.query.code) {
            if (router.query.type == 'error') {
                setErrorMessage(router.query.m)
                setShowErrorMessage(true)
                setMessageType('error')

                setTimeout(() => {
                    setShowErrorMessage(false)
                    router.push('/auth')
                }, 1000);
            } else {
                setFormData(k => ({ ...k, code: router.query.code }))

            }
        }
    }, [])

    useEffect(() => {
        if (closeIframe)
            setModalIframe(false)

    }, [closeIframe])


    useEffect(() => {
        if (isCheckedInp) {
            setisDisabeled('')
            setAgreement(true)
        }
        else {
            setisDisabeled('disabled')
            setAgreement(false)
        }
    })

    const onChangeRegister = (e) => {
        const { name, value } = e.target

        if (errorMessage) setErrorMessage('')

        if (name === 'phone' || name === 'parental_code' || name === 'password') {
            if (name === 'parental_code' && value.length < 5 && !isNaN(value)) {
                setFormData(k => ({ ...k, [name]: value }))
            }
            if (name === 'password' && value.length <= 64) {
                setFormData(k => ({ ...k, [name]: value }))
            }
            if (name === 'phone' && (value == '+' || !isNaN(value))) {
                setFormData(k => ({ ...k, [name]: value }))
            }
        } else if (name === 'email') {
            validateEmail(value)
            setFormData(prev => ({ ...prev, [name]: value }))
        } else {
            setFormData(prev => ({ ...prev, [name]: value }))
        }
    }

    function validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        setValidateEmailVal(re.test(email))
    }

    const btn_register = (e) => {
        e.preventDefault()

        if (!isDisabeled) {
            if (!agreement) setValidate(true)

            for (let key in formData) {
                if (!formData[key] && key !== 'phone') {
                    setValidate(true)
                    break
                } else {
                    setValidate(false)
                    if (key === 'parental_code' && formData[key].length != 4) {
                        setShowErrorMessage(true)
                        setMessageType('error')
                        setErrorMessage('Parental Code must be minimum of 4 characters')
                        setValidate(true)
                        setFormData(prev => ({
                            ...prev,
                            parental_code: ''
                        }))
                        hide_error_message()
                        break
                    } else {
                        if (formData.c_password !== formData.password) {
                            setShowErrorMessage(true)
                            setMessageType('error')
                            setErrorMessage('Password and confirm password must be same')
                            setValidate(true)
                            setFormData(prev => ({
                                ...prev,
                                c_password: ''
                            }))
                            hide_error_message()
                            break
                        }
                        else {
                            if (key === 'password') {
                                if (formData[key].length < 8) {
                                    setShowErrorMessage(true)
                                    setMessageType('error')
                                    setFormData(prev => ({
                                        ...prev,
                                        password: '',
                                        c_password: ''
                                    }))
                                    setValidate(true)
                                    setErrorMessage('Password must be minimum of 8 characters')
                                    hide_error_message()
                                } else {
                                    request_register()

                                }
                            }
                        }
                    }
                }
            }
        }

    }

    const hide_error_message = () => {
        setTimeout(() => {
            setShowErrorMessage(false)
        }, 3000)
    }

    const request_register = () => {
        const body = {
            code: formData.code,
            parental_code: '0000',
            password: formData.password,
            phone: formData.phone,
            surname: formData.name.trim().split(' ')[1] || '',
            name: formData.name.trim().split(' ')[0],
            device_id: localStorage.getItem('device_id'),
            // delete username register req
            // username: Date.now(),
        }
        delete body.c_password

        register_user(body,
            data => {
                // if (router.query.from) {
                //     console.log(data)
                //     router.push(`/auth?from=${router.query.from}&token=${data}`)
                // } else {
                // }
                setMessageType('success')
                setErrorMessage('Registration successful')
                setShowErrorMessage(true)
                setTimeout(() => {
                    setShowErrorMessage(false)
                    router.push(`/auth`)
                }, 1000);

                // login_request()
            },
            err => {
                let _type = ''
                setShowErrorMessage(true)
                setErrorMessage(err)
                hide_error_message()
            })
    }

    const login_request = () => {

        let result

        if (localStorage.getItem('device_id')) result = localStorage.getItem('device_id')
        else {
            result = generate_id()
            localStorage.setItem('device_id', result)
        }


        let device_info = info_device()

        var body = {
            username: formData.phone,
            password: formData.password,
            device_id: result,
            device_model: device_info.split(' ')[0],
            device_name: device_info.split(' ')[1]
        }
        sing_in(body, res => {
            localStorage.setItem('token', crypt('token', res))
            localStorage.setItem('root', crypt('root', JSON.stringify(body)))
            setSigningIn(true)
            autoSignInSubUser(router, null, () => setSigningIn(false))
        }, err => {
            console.log(err)
        })

    }

    const openModalPage = (e, title) => {
        setModalIframe(true)
        setIframeUrl(e)
        setIframeTitle(title)
    }

    const isChecked = (e) => {
        if (e.target.checked)
            setIsCkechedInp(true)
        else
            setIsCkechedInp(false)
    }
    const closePage = () => {
        setCloseIframe(true)
    }
    const stopPropagationPopup = (e) => {
        e.stopPropagation()
    }
    if (signingIn) return <Loading />

    return (
        <>
            <ErrorMessage text={errorMessage} type={messageType} show={showErrorMessage} />

            <div id="register">
                <h1 className="title_register_field">{translateWord('Register', 'Register')}</h1>
                <div className="registration">
                    <form action="" onSubmit={btn_register}>
                        {/* <label htmlFor="" className="required">{translateWord('username', 'Username')}:</label>
                        <input className={validate && !formData.username.length ? 'not_valid_register' : ''} type="text"
                            value={formData.username} name={'username'} onChange={onChangeRegister} /> */}
                        <label htmlFor="" className="required label">{translateWord('name', 'Name')}:</label>
                        <input className={validate && !formData.name.length ? 'not_valid_register' : ''} type="text"
                            value={formData.name} name={'name'} onChange={onChangeRegister} />
                        {/* <label htmlFor="" className="required label">{translateWord('email', 'E-Mail')}:</label>
                        <input className={validate && !formData.email.length ? 'not_valid_register' : ''} type="text"
                            value={formData.email} name={'email'} onChange={onChangeRegister} /> */}
                        <label htmlFor="" className="label">{translateWord('phone', 'Phone')}:</label>
                        <input placeholder={'+1 12 345 678'}
                            className={''} type="text"
                            value={formData.phone} name={'phone'} onChange={onChangeRegister} />
                        <div className="passwords_field_register">

                            <div className="child_passwords_field">
                                <label htmlFor="" className="required label">{translateWord('password', 'Password')}:</label>
                                <input className={validate && formData.password.length < 8 ? 'not_valid_register' : ''}
                                    type="password" value={formData.password} name={'password'}
                                    onChange={onChangeRegister} />
                            </div>
                            <div className="child_passwords_field">
                                <label htmlFor="" className="required label">{translateWord('Confirm password', 'Confirm password')}:</label>
                                <input
                                    className={validate && formData.c_password.length < 4 ? 'not_valid_register' : ''}
                                    type="password" value={formData.c_password} name={'c_password'}
                                    onChange={onChangeRegister} />
                            </div>
                        </div>
                        <div className="agreement-and-peliminary">
                            <div className="peliminary">
                                <input type='checkbox' id="policy" onClick={e => isChecked(e)} onChange={onChangeRegister} />
                                <label for="policy">{translateWord('I have read and approved the', 'I have read and approved the')}
                                    <span onClick={() => openModalPage('https://www.tivimivi.com/preliminary', 'PRELIMINARY AGREEMENT')}>
                                        {translateWord('preliminary', 'preliminary')}
                                    </span>
                                    {translateWord(' and', ' and')}
                                    <span onClick={() => openModalPage("https://www.tivimivi.com/membership", 'MEMBERSHIP AGREEMENT')}>
                                        {translateWord('membership', 'membership')}
                                    </span>
                                    {translateWord(' agreement and', ' agreement and')}
                                    <span onClick={() => openModalPage("https://www.tivimivi.com/privacy", 'PRAVICY POLICY AGREEMENT')}>
                                        {translateWord('pravicy policy', 'pravicy policy')}
                                    </span>
                                </label>

                                {
                                    modalIframe ?
                                        <SignUpModal
                                            iframeUrl={iframeUrl}
                                            iframeTitle={iframeTitle}
                                            setCloseIframe={setCloseIframe}
                                            closeIframe={closeIframe}
                                            closePage={closePage}
                                            stopPropagationPopup={stopPropagationPopup} />
                                        :
                                        null
                                }

                            </div>
                        </div>
                        <button type={'submit'} className={'btn_register card_color ' + isDisabeled}>{translateWord('Sign up', 'Sign up')}</button>
                        <p>
                            {translateWord('Already have an account?', 'Already have an account?')}{' '}
                            <NavLink to={'/auth'}>{translateWord('Sign In', 'Sign In')} </NavLink>
                        </p>
                    </form>
                </div>
            </div>
        </>

    )
}

